<template>
    <div>
        <div style="display: flex;width:100%">
            <div style="margin-top: 10px;text-align: center;width:100%" class="tab">
                <el-card class="box-card">
                    <div>
                        <table>
                            <tr>
                                <td style="width:60px">{{ $t('getapi[1964]') }}：</td>
                                <td style="width:150px;">
                                    <el-input v-model="year" type="text" size="mini"></el-input>
                                </td>
                                <td style="width:60px">{{ $t('getapi[3437]') }}：</td>
                                <td style="width:150px;">
                                    <routejump :urlNo="5">
                                        <el-input
                                                v-model="item_code"
                                                type="text"
                                                size="mini"
                                        >
                                            <i  class="el-icon-edit el-input__icon"  slot="suffix" @click="selectItemName()"></i>

                                        </el-input>
                                    </routejump>
                                </td>
                                <td>
                                    <el-button type="primary" size="mini" @click="search" style="margin-left: 8px">{{$t('getapi[1980]')}}</el-button>
                                </td>
                            </tr>
                        </table>
                    </div>
                </el-card>
                <el-card class="box-card">
                    <div>
                        <div id="main" :style="{ width: '100%', height: tableHeight + 'px' }"></div>
                    </div>
                </el-card>

            </div>
        </div>
        <el-dialog v-dialogDrag :visible.sync="detailVisiable" width="60%" :close-on-click-modal="false">
            <div>
                <div id="detail" :style="{ width: '100%', height: tableHeight + 'px' }"></div>
            </div>
        </el-dialog>
        <!-- 项目名称 -->
        <selector :isVisible="false" :isBatch=false :selectType="0" :isSplitPage=true
                  :postUrl="'Basic/GetENGITEMList'" @callback="getItemName" ref="itemname"></selector>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    import { Loading } from 'element-ui';
    import echarts from 'echarts';
    import 'echarts-gl';
    export default {
        name: '4_weeklydppm',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight-200
            }
        },
        data() {
            return {
                charts: '',
                year: '',
                item_code:'',
                custom: '',
                data: [],
                dataDetail:[],
                detailVisiable: false,
                chartsdetail:'',
            };
        },
        beforeDestroy(){
        },
        mounted: function () {
            let that = this;
            that.year = new Date().getFullYear()
        },
        methods: {
            search(){
                let that = this
                if(that.year == ''){
                    that.$message.warning(this.$t("getapi[3091]"))
                    return false
                }
                let parm = {
                    "Code": that.year,
                    "Name": that.item_code,
                    "LangType":that.$processdata.getLang()
                };
                let loadingInstance = Loading.service(Common.maskoption1);
                that.$http.urlpost('/Kpi/GetProDPPMRate', parm, function (res) {
                    if (res.Success == 1) {
                        that.data = res.DataContent.Table
                        that.draw(that.data)
                    }
                    loadingInstance.close()
                });

            },
            // 图标
            draw(dataContent){
                let that = this;
                let datax = [];
                let datay = []
                let dataObjects = []
                if (dataContent.length == 0) {
                    //alert('没有数据');
                    datax = [0,0,0,0,0,0,0,0,0,0,0,0]
                    datay = [0,0,0,0,0,0,0,0,0,0,0,0]
                } else {
                    for(let i = 0;i<dataContent.length;i++){
                        let weekDisplay = 'W'+(dataContent[i].WeekNumber<10?('0'+dataContent[i].WeekNumber):dataContent[i].WeekNumber)
                        datax = [...datax,weekDisplay]
                        datay = [...datay,dataContent[i].DPPM]
                        dataObjects = [...dataObjects, {
                            ...dataContent[i],
                            weekDisplay: weekDisplay
                        }];
                    }
                }
                that.charts = echarts.init(document.getElementById("main"));
                let option = {
                    title: {
                        text: that.year+ 'Weekly DPPM',
                        x:'center',
                        y:'top',
                        textAlign:'left'
                    },
                    xAxis: {
                        type: 'category',
                        label: {
                            show: true,
                            position: 'insideRight'
                        },
                        data: datax
                    },
                    yAxis: {
                        type: 'value',
                        axisLabel: {
                            formatter: '{value}'
                        },
                    },
                    series: [{
                        data: datay,
                        type: 'bar',
                        showBackground: true,
                        backgroundStyle: {
                            color: 'rgba(220, 220, 220, 0.8)'
                        },
                        itemStyle:{
                            normal:{
                                color:'#409eff'
                            }
                        },
                        label: {
                            normal: {
                                show: true,
                                position: 'top'
                            }
                        },
                    }]
                }
                that.charts.clear();
                that.charts.setOption(option);
                that.charts.on("click",function(params){
                    console.log(params)
                    let clickedWeek = params.name;
                    let clickedData = dataObjects.find(item => item.weekDisplay === clickedWeek);
                    if(clickedData){
                        that.detailVisiable = true
                        setTimeout(() => {
                            let parm = {
                                "BeginDate": clickedData.WeekStartDate,
                                "EndDate": clickedData.WeekEndDate,
                                "itemcode": that.item_code,
                            }
                            let loadingInstance = Loading.service(Common.maskoption1);
                            that.$http.urlpost('/Kpi/GetProDPPMReason', parm, function (res) {
                                if (res.Success == 1) {
                                    that.dataDetail = res.DataContent.Table
                                    if(that.dataDetail.length > 0){
                                        that.drawDetail(that.dataDetail,clickedWeek)
                                    }
                                }
                                loadingInstance.close()
                            });
                        }, 500);
                    }
                })
            },
            drawDetail(data,name){
                let that = this;
                console.log(data)
                that.chartsdetail = echarts.init(document.getElementById("detail"));
                let list = {
                    datax: [],
                    data1:[],
                    data2:[]
                }
                let maxnum=0
                for(let i=0;i<data.length;i++){
                    list.datax = [...list.datax,(data[i]['原因'])]
                    list.data1 = [...list.data1,data[i]['数量']]
                    list.data2 = [...list.data2,data[i]['占比'].replace('%', '')]
                    maxnum = maxnum + data[i]['数量']
                }
                let option = {
                    title: {
                        text: that.item_code + '第' + name + '周内部制程问题分析',
                        x:'center',
                        y:'top',
                        textAlign:'left'
                    },
                    legend: {
                        data: ['数量', '占比'],
                        right: 50,
                    },
                    xAxis: {
                        type: 'category',
                        label: {
                            show: true,
                            position: 'insideRight'
                        },
                        data: list.datax
                    },
                    yAxis: [
                        {
                            type: 'value',
                            min: 0,
                            max: maxnum,
                            name: '数量',
                            axisLabel: {
                                formatter: '{value}'
                            },
                            splitLine: {
                                show: false  // 隐藏网格线
                            }
                        },
                        {
                            type: 'value',
                            min: 0,
                            max: 100,
                            name: '占比',
                            axisLabel: {
                                show: true,
                                formatter: function(value) {
                                    return value + '%';
                                }
                            },
                            splitLine: {
                                show: false  // 隐藏网格线
                            }
                        },
                    ],
                    series: [{
                        name:'数量',
                        data: list.data1,
                        type: 'bar',
                        showBackground: true,
                        itemStyle:{
                            normal:{
                                color:'#409eff'
                            }
                        },
                        label: {
                            normal: {
                                show: true,
                                position: 'top'
                            }
                        },
                    },{
                        name:'占比',
                        data: list.data2,
                        type: 'scatter',
                        showBackground: true,
                        yAxisIndex: 1,
                        itemStyle:{
                            normal:{
                                color:'#ff2e43'
                            }
                        },
                        label: {
                            normal: {
                                show: true,
                                position: 'top',
                                formatter: '{c}%',
                                offset: [0, -10],
                            }
                        }
                    }]
                }
                that.chartsdetail.clear();
                that.chartsdetail.setOption(option);
            },
            selectItemName() {
                let that = this;
                that.$refs.itemname.clearInput(true);
            },
            getItemName(data) {
                let that = this
                console.log(data)
                that.item_code = data.ITEM_CODE
            },
        }
    };
</script>

<style scoped lang="less">

</style>
